export default ({ app }) => {
  app.router.afterEach(to => {
    const isPdp = to.path.includes("/products/");
    const isPlp = to.path.includes("/collections/");
    const isBecomeAMember = to.path.includes("/become-a-member");

    if (!isPdp && !isPlp && !isBecomeAMember) return;

    const MAX_RETRIES = 30;
    let attempt = 0;

    const tryRefresh = () => {
      const y = window.yotpo;

      if (y && typeof y.refreshWidgets === "function") {
        y.refreshWidgets();
        return;
      }

      if (window.yotpoLoader && typeof window.yotpoLoader.load === "function") {
        window.yotpoLoader.load();
        return;
      }

      if (attempt < MAX_RETRIES) {
        attempt++;
        setTimeout(tryRefresh, 500);
      }
    };

    // Delay to ensure new DOM is mounted
    setTimeout(tryRefresh, 1000);
  });
};
